<template>
  <InputNumber
    :id="id"
    :value="value"
    :disabled="disabled"
    :min="min"
    :max="max"
    mode="decimal"
    locale="de-DE"
    :minFractionDigits="minFractionDigits"
    :maxFractionDigits="effectiveMaxFractionDigits"
    :suffix="unitSuffix"
    :placeholder="unitPlaceholder"
    @input="$emit('input', $event)"
  />
</template>

<script>
import InputNumber from 'primevue/inputnumber';

export default {
  name: 'UnitInputNumber',
  components: {
    InputNumber,
  },
  props: {
    value: {
      default: null,
    },
    unit: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
    minFractionDigits: {
      type: Number,
      default: 2,
    },
    maxFractionDigits: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    effectiveMaxFractionDigits() {
      if (this.maxFractionDigits !== undefined) {
        return this.maxFractionDigits;
      }
      return this.minFractionDigits;
    },
    unitPlaceholder() {
      return this.$t(this.unit);
    },
    unitSuffix() {
      return ` ${this.unitPlaceholder}`;
    },
  },
};
</script>
